<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        
        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',0)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Assignment ({{mycontent.content.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.a">
                <v-flex xs12 >
                    <quill-editor v-model='mycontent.content' :options="getEditorOptionSpecial()" ref="myQuill">
                        <div :id="getToolbar(ltype)" slot="toolbar">
                            <span class="ql-formats">
                                <button class="ql-header" value="1"></button>
                                <button class="ql-header" value="2"></button>
                            </span>        
                            <span class="ql-formats">
                                <button class="ql-bold"></button>
                                <button class="ql-italic"></button>
                                <button class="ql-underline"></button>
                                <button class="ql-strike"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-code-block"></button>
                                <select class="ql-color"></select>
                                <select class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-align"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-link"></button>
                                <button class="ql-image"></button>
                                </span>
                            <span class="ql-formats">
                                <button class="ql-clean"></button>
                            </span>

                            <span class="ql-formats">
                                <button  @click="markAsUnknown()"><v-icon>dynamic_feed</v-icon></button>
                            </span>
                        </div>
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlC">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlC" v-model=HtmlContent>
                </v-textarea>
            </div>
        </div>

        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',1)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Help ({{mycontent.help.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.b">
                <div>
                    <v-flex xs12>
                        <quill-editor v-model="mycontent.help" :options="getEditorOption()">
                        </quill-editor>
                    </v-flex>
                    <v-flex xs12 justify-end>
                        <v-btn @click="showHtmlH">Show HTML</v-btn>
                        <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                    </v-flex>
                    <v-textarea v-if="showedHtmlH" v-model=HtmlHelp>
                    </v-textarea>
                </div>
            </div>
            
                <v-card>
                    <v-card-title>Data to fill: <v-btn @click="getAnswers()">Analyse</v-btn></v-card-title>
                    <v-card-text v-if="fillData.length > 0">
                        <v-chip v-for="(fd,index) in fillData" :key="index">{{fd}}</v-chip>
                    </v-card-text>
                </v-card>

                <v-card v-if="getFakes">  
                    <v-card-title>Fakes:</v-card-title>          
                    <v-card-text>
                        <div v-if="mycontent.fakes.length>0">Click to delete</div>
                        <v-chip v-for="(fk,index) in mycontent.fakes" :key="index" @click="mycontent.fakes.splice(index,1)">{{fk}}</v-chip>
                    </v-card-text>
                    <v-card-actions>
                        <v-text-field
                            label="Insert new fake"
                            placeholder="Type and press Enter"
                            v-model = "another"
                            @keydown.enter.prevent="addFake"
                        ></v-text-field>
                    </v-card-actions>
                </v-card>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import hljs from 'highlight.js'
import { quillEditor } from 'vue-quill-editor'
// import 'highlight.js/styles/googlecode.css'
//import { ImageDrop } from 'quill-image-drop-module'
//import ImageResize from 'quill-image-resize-module'

export default {
    data() {
        return {
                showedHtmlC : false,
                showedHtmlH : false,
                mycontent:  {
                    content: 'loading...',
                    help: 'loading...',
                    fakes : []
                },
                HtmlContent: '',
                HtmlHelp: '',
                another: null,    
                fillData: []            
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getContent567',
                            'getCollapses',
                            'getFakes'
                        ])
    ,
    components: {
        quillEditor
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.content
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.content = this.HtmlContent
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },
        addFake() {
            if (this.another) {
                this.mycontent.fakes.push(this.another)
                this.another = null
            }
        },
        cleanSpan(txt) {
           var output = txt 
           var start = 0
           var end = 0
           while (output.indexOf('<span class="hljs') > -1) {
              start = output.indexOf('<span class="hljs')
              end = output.indexOf('>', start)
              output = output.substring(0,start) + output.substring(end+1)
           }
           while (output.indexOf('</span>') > -1) {
              start = output.indexOf('</span')
              end = output.indexOf('>', start)
              output = output.substring(0,start) + output.substring(end+1)
           }
           return output
        },
        getAnswers() {
            this.fillData = []
            var result = this.cleanSpan(this.mycontent.content)
            let answers = this.fillData            
            result.replace(/§§(.*?)§§/g, function(match, g1) { 
                answers.push(g1)
            })

            for(let i=0; i<answers.lenght; i++) {
                answers[i] = this.unSpan(answers[i])
            }
        },
        unSpan(txt) {
            var data = txt
            var start = 0
            var end = 0
            while (data.indexOf('<span') > -1) {
                start = data.indexOf('<span')
                end = data.indexOf('>',start)
                data = data.substring(0,start) + data.substring(end+1)
                start = data.indexOf('</span>')
                data = data.substring(0,start) + data.substring(start+7)
            }
            return data
        },

        /************************************************************ */
        saveActualContent(mylang) {   
            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent567', data)            
        },

        refreshData() {
           // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContent567fromStore(lang_id) {
            return this.getContent567(lang_id)
        },

        readFromStore() {
            var con = -1
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                con = this.getContent567fromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContent567fromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        },        
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
          /*          syntax: {
                    highlight: text => hljs.highlightAuto(text).value
                    },
            */        imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        },
        getEditorOptionSpecial() {
          return {
                    modules: {
                        toolbar: '#' + this.getToolbar(this.ltype),
          /*              syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                        },
            */            imageDrop: true,
                        imageResize: true
                    },
                        theme: 'snow'
                }
        },
        getToolbar(ltype) {
            return 'toolbar' + ltype
        },
        markAsUnknown() {
            const quill = this.$refs.myQuill.quill
            var selection = quill.getSelection();
            if (selection == null || selection.length == 0  ) return
            // var selectedContent = quill.getContents(selection.index, selection.length);
            quill.insertText(selection.index + selection.length, '§§')
            quill.insertText(selection.index, '§§')
            quill.setSelection(selection.index, selection.length + 4)
        }

    } 

}
</script>


<style>

</style>


